<template>
  <div class="container">
    <div class="row">
      <div class="col 2-col">
        <h2 id="cryosphere">6. Cryosphere</h2>
        <h3>6.1. Glaciers and Permafrost</h3>
        <p>According to the Randolph Glacier Outlines dataset this mountain range contains <strong>{{ factsheet.data.mountain_cryo.num_glaciers }} glaciers</strong> with a total area of <strong>{{ factsheet.data.mountain_cryo.glaciated_area | km2 }}</strong> (<strong>{{ (100*(factsheet.data.mountain_cryo.glaciated_area/factsheet.data.mountain_cryo.total_area)) | percent }}</strong>) area of glacier coverage. In addition to the glacier coverage, it is estimated that under favourable conditions, permafrost is possible in <strong>{{ factsheet.data.mountain_cryo.permafrost_possible | km2 }}</strong>, and that it is likely to occur in at least <strong>{{ factsheet.data.mountain_cryo.permafrost_likely | km2 }}</strong>. The map shows the glaciated areas in light blue, and the areas where permafrost is possible in purple.

        </p>

      </div>
    </div>
    <div class="row">
      <div class="col col-8">
        <ImageMap 
          title="Permafrost and glacier extent" 
          num="5.1" 
          v-bind:images="[{title:'test',source:'/mountain_cryo/Cryosphere.png'}]" 
          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          attribution="Data: GLIMS/Randolph Glaciers/Permafrost Zonation">
        </ImageMap>
      </div>
      <div class="col col-4">
        <table class="table table-sm">
          <caption>Largest Glaciers</caption>
          <tr>
            <th>Name</th><th></th>
          </tr>
          <tr v-for="glacier in factsheet.data.mountain_cryo.glaciers_main.slice(0,10)">
            <td>{{ glacier.name }}</td>
          </tr>
        </table>
      </div>
    </div>


    <div class="row">
      <div class="col">
        <h3>6.2. Snow Cover</h3>
        <p>
          Monthly mean snow cover in the area between 2000-2020 varied between <strong>{{ this.factsheet.data.mountain_cryo.snow_cover_monthly_sorted[11]['value'] | km2 }}</strong> and <strong>{{ this.factsheet.data.mountain_cryo.snow_cover_monthly_sorted[0]['value'] | km2 }}</strong>. The three months of the year with the most snow cover are <strong>
          {{ this.factsheet.data.mountain_cryo.snow_cover_monthly_sorted[0]['month_name'] }} ({{ this.factsheet.data.mountain_cryo.snow_cover_monthly_sorted[0]['value'] | km2 }}), 
          {{ this.factsheet.data.mountain_cryo.snow_cover_monthly_sorted[1]['month_name'] }} ({{ this.factsheet.data.mountain_cryo.snow_cover_monthly_sorted[1]['value'] | km2 }}), and
          {{ this.factsheet.data.mountain_cryo.snow_cover_monthly_sorted[2]['month_name'] }} ({{ this.factsheet.data.mountain_cryo.snow_cover_monthly_sorted[2]['value'] | km2 }})</strong>. The chart below shows the mean snow cover for all months in the year, and the map shows the month with the highest average snow cover (<strong>{{ this.factsheet.data.mountain_cryo.snow_cover_monthly_sorted[0]['month_name'] }}</strong>).

        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-8">

        <ImageMap 
          title="Maximum Monthly Snow Cover" 
          num="5.2" 
          v-bind:images="[{title:'test',source:'/mountain_cryo/SnowCover.png'}]" 
          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          attribution="Data: Enveo/ESA-CCI">
        </ImageMap>

      </div>
      <div class="col-4">
        <Figure 
          title="Mean Monthly Snow Cover" 
          num="5.1"
          src="mountain_cryo/SnowCoverChart.svg"
          label="Mean monthly snow cover from 2000-2020." 
          attribution="Data: Enveo/CCI."

          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          >
        </Figure>

      </div>

    </div>


  </div>


</template>

<script>
    /* eslint-disable */
    import ImageMap from '@/components/factsheet/maps/ImageMap.vue'
    import Figure from '@/components/factsheet/Figure.vue'

    import _ from 'lodash';

    export default {
        name: 'Cryosphere',
        components: { ImageMap, Figure },
        props: ['location', 'factsheet', 'loaded'],
        data() {
            return {
            }
        },
        created() {
        },
        computed: {
          snowCoverMin() {
            return this.factsheet.data.mountain_cryo.snow_cover_monthly_sorted[11]['value']
          },
          snowCoverMax() {
            return this.factsheet.data.mountain_cryo.snow_cover_monthly_sorted[0]['value']
          },
          
        },
        mounted() {
        },
        filters: {
          percent: function (value) {
            return value.toFixed(1)+'%'
          },
          km2: function(value) {
            return (value/1000000).toFixed(1)+" km²"
          },
          area_as_percent: function(value) {

          }

        },
        methods: {
          urlFor(asset) {
            return process.env.VUE_APP_API+'/api/data/factsheet/'+this.factsheet.info.identifier+'/data/'+asset;
          },
          andList(list, attr, attrpercent) {
            var ret = ""
            for(var i=0; i<list.length;i++) {
              var percent = attrpercent ? ' ('+list[i][attrpercent]+'%)' : ''
              if (list.length == 1) {
                return list[i][attr]+percent
              }
              if(i == list.length-1) {
                ret += " and "+list[i][attr]+percent
              } else {
                ret += list[i][attr]+percent+", "
              }
            }
            return ret
          }
        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
</style>

<style scoped>

caption {
  caption-side: top;
  font-weight:bold;
  font-size:1em;
  padding:5px;
  color:rgb(33, 37, 41);
  padding-left:0px;
}
table {
   font-size:0.75em;
}
table th, table td {
  padding-left:0px;
}

</style>